import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // Get elements
        this.$stats = this.$('stat')
        this.$content = this.$('content')

        // Bind methods
        this.onResizeBind = this.onResize.bind(this);
    }

    /////////////////////////
    // Lifecycle
    init() {
        this.bindEvents()
        this.onResize()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    /////////////////////////
    // Events
    bindEvents() {
        window.addEventListener("resizeEnd", this.onResizeBind);
    }

    unbindEvents() {
        window.removeEventListener("resizeEnd", this.onResizeBind);
    }

    /////////////////////////
    // Callbacks
    onResize() {
        this.computeWidth(this.$stats, '--stat-width')
        this.computeWidth(this.$content, '--content-width')
    }

    /////////////////////////
    // Methods
    computeWidth($items, cssVar) {

        this.el.style.setProperty(cssVar, `auto`);

        requestAnimationFrame(() => {
            let widthArr = []
            
            let itemIndex = 0
            while (itemIndex < $items.length) {
                widthArr.push($items[itemIndex].offsetWidth)
                itemIndex++
            }
    
            if (widthArr.length < 1) return
    
            const maxWidth = Math.max(...widthArr)
    
            this.el.style.setProperty(cssVar, `${maxWidth}px`);
        })
    }
}
